import React from 'react'
import NavigateNext from '@mui/icons-material/NavigateNext'
import { Breadcrumbs, Link } from '@mui/material'
import PropTypes from 'prop-types'

const BreadcrumbsMUI = (props) => {
  const { crumbs } = props

  return (
    <Breadcrumbs
      separator={<NavigateNext fontSize='small' />}
      aria-label='batchUpdate-breadcrumbs'
    >
      {crumbs.map(({ route, name }, index) => {
        return (
          <Link
            underline='hover'
            key={`${name}-${index}`}
            color={index === crumbs.length - 1 ? 'blue' : 'inherit'}
            href={route}
          >
            {index === crumbs.length - 1 ? <strong> {name} </strong> : name}
          </Link>
        )
      })}
    </Breadcrumbs>
  )
}

BreadcrumbsMUI.propTypes = {
  crumbs: PropTypes.array
}

export default BreadcrumbsMUI
